import { InfoElement } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumberWithCurrency, getDifferenceWithPrecision, handleNullCase } from 'utils'

function Revenue({ revenueCompared, revenueCurrent, revenuePercent, revenueMax }) {
  const { t: translate } = useTranslation()
  const getUnits = (unit, handleNull) =>
    formatNumberWithCurrency({
      number: handleNull ? handleNullCase(unit) : unit,
      translate,
      currency: '',
      precision: 2,
    })
  const current = getUnits(revenueCurrent)
  const compared = getUnits(revenueCompared, true)
  const progress = (revenueCurrent * 100) / revenueMax

  return (
    <div className="store-result-compare">
      <div>
        <b>{current} /</b> {compared}
        <div className="progress-wrapper">
          <span className="progress-line" style={{ width: `${progress}%` }} />
        </div>
      </div>

      <InfoElement
        percentDifference={getDifferenceWithPrecision({
          handleNullCase: true,
          number: revenuePercent,
          translate,
        })}
      />
    </div>
  )
}

Revenue.propTypes = {
  revenueCompared: PropTypes.number,
  revenueCurrent: PropTypes.number,
  revenueMax: PropTypes.number,
  revenuePercent: PropTypes.number,
}

export default Revenue
